// material-ui
import { styled } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";

// project-imports
import { DRAWER_SLOT_WIDTH, MINI_DRAWER_SLOT_WIDTH } from "config";

// ==============================|| HEADER - APP BAR STYLED ||============================== //

const AppBarStyled = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(!open && {
    marginLeft: MINI_DRAWER_SLOT_WIDTH,
    width: `calc(100% - ${MINI_DRAWER_SLOT_WIDTH}px)`,
  }),
  ...(open && {
    marginLeft: DRAWER_SLOT_WIDTH,
    width: `calc(100% - ${DRAWER_SLOT_WIDTH}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export default AppBarStyled;
